/* Copyright 2011-2013 The MathWorks, Inc. */

/**
 * This defines a list of constant values that can be assigned to the orientation property of a
 * control.
 */

define([], function () {
    return {
        VERTICAL: "Vertical",
        HORIZONTAL: "Horizontal"
    };
});